<template>
    <div class="display-contents">
        <action-sheet v-model="visible">
            <div
                class="py16 py25-md position-relative budget-container d-flex flex-column"
            >
                <button
                    type="button"
                    @click.prevent="close()"
                    class="btn p0 border0 text-neutral-500 title-small position-absolute top-0 end-0 mt10"
                >
                    <i class="bx bx-x"></i>
                </button>

                <div class="illustration">
                    <img
                        loading="lazy"
                        src="/v2/img/icons/budget-cta-image.svg"
                        class="d-block w-100 h-100"
                    />
                </div>

                <div class="mt0 mt25-lg budget-content">
                    <div v-if="step == 1">
                        <h3
                            class="text-neutral-700 fw-bold title-xsmall mb16 p0"
                        >
                            Me conta, o que você precisa resolver hoje?
                        </h3>
                        <div class="mt16 body-medium text-neutral-700">
                            Escreva do seu jeito e receba contatos confiáveis
                            diretamente no seu WhatsApp.
                        </div>

                        <textarea
                            class="br16 border1 border-neutral-300 w-100 p15 message mt25"
                            v-model="form.mensagem"
                            placeholder="Ex.: Estou reformando minha casa e preciso de ajuda com alguns materiais"
                        ></textarea>
                    </div>

                    <div v-if="step == 2">
                        <h3
                            class="text-neutral-700 fw-bold title-xsmall mb0 p0"
                        >
                            Quais categorias te interessam?
                        </h3>
                        <span class="text-xsmall text-neutral-700 mb16">(selecione pelo menos uma)</span>
                        <input
                            type="text"
                            class="border1 border-neutral-300 p12 br12 mb20 mt10 w-100"
                            v-model="subcategoryTerm"
                            placeholder="Buscar categorias"
                        />

                        <div
                            v-if="
                                segments === false && !loadingSegments
                            "
                        >
                            <div
                                class="p15 bg-warning-100 border1 border-warning-200 br16"
                            >
                                Ops! Ocorreu um problema e não conseguimos
                                carregar as categorias.

                                <a
                                    href="#"
                                    class="text-decoration-none d-block text-brand-500 text-brand-400-hover"
                                    @click.prevent="loadSegments"
                                    >Tentar novamente</a
                                >
                            </div>
                        </div>

                        <div class="subcategories d-flex flex-wrap gap8 mb20">
                            <button
                                v-for="(
                                    segment, index
                                ) in form.segmentos"
                                class="border0 text-white body-medium bg-secondary-500 br16 px16 py8 d-flex align-items-center"
                            >
                                {{ segment.nome }}
                                <span
                                    class="text-secondary-300 body-small p5"
                                    @click.prevent="
                                        unselectCategory(segment, index)
                                    "
                                >
                                    <i class="bx bx-x"></i>
                                </span>
                            </button>
                            <button
                                v-for="(
                                    segment, index
                                ) in filteredSegments"
                                class="border1 border-secondary-200 body-medium bg-secondary-100 br16 px16 py8"
                                @click.prevent="
                                    selectCategory(segment, index)
                                "
                            >
                                {{ segment.nome }}
                            </button>
                        </div>
                    </div>

                    <div v-if="step == 3">
                        <h3
                            class="text-neutral-700 fw-bold title-xsmall mb16 p0"
                        >
                            Suas informações de contato
                        </h3>

                        <input
                            type="text"
                            class="border1 border-neutral-300 p12 br12 mb20 w-100"
                            v-model="form.nome"
                            placeholder="Informe seu nome"
                        />

                        <input
                            type="text"
                            class="border1 border-neutral-300 p12 br12 mb20 w-100"
                            v-mask-phone.br
                            v-model="form.whatsapp"
                            placeholder="Whatsapp com DDD"
                        />

                        <select-searchable
                            v-model="form.cidade"
                            :options="cidades"
                            placeholder="Cidade"
                            value-key="slug"
                            label-key="nome"
                            class="w-100"
                        ></select-searchable>

                        <select-searchable
                            v-model="form.bairro"
                            :options="bairros"
                            placeholder="Bairro"
                            value-key="slug"
                            label-key="nome"
                            class="w-100"
                        ></select-searchable>
                    </div>
                </div>
                <div class="budget-progress">
                    <div class="step" :class="{ active: step >= 1 }"></div>
                    <div class="step" :class="{ active: step >= 2 }"></div>
                    <div class="step" :class="{ active: step >= 3 }"></div>
                </div>

                <div class="budget-footer">
                    <button
                        type="button"
                        class="border0 bg-brand-500 w-100 br100 text-white fw-bold py10 mt20"
                        v-if="step < 3"
                        @click="step++"
                        :disabled="buttonDisabled"
                    >
                        Continuar
                    </button>

                    <div
                        v-if="errors.length"
                        class="p15 bg-error-100 border1 border-error-200 br16 mt20"
                    >
                        <div
                            v-for="error in errors"
                            :key="error"
                            class="text-error-700"
                        >
                            {{ error }}
                        </div>
                    </div>

                    <div
                        v-if="success"
                        class="p15 bg-success-100 border1 border-success-200 br16 mt20"
                    >
                        Cotação enviada com sucesso! Aguarde o contato dos
                        nossos parceiros
                    </div>

                    <button
                        type="button"
                        class="border0 w-100 br100 text-white fw-bold py10 mt20 bg-brand-500"
                        :disabled="buttonDisabled"
                        v-if="step == 3"
                        @click="sendBudget()"
                    >
                        <span v-if="!loadingBudget">Enviar cotação </span>
                        <i class="bx bx-loader-alt bx-spin" v-else></i>
                    </button>

                    <button
                        type="button"
                        class="w-100 mt10 py10 text-neutral-700 bg-white border0"
                        @click.prevent="step -= 1"
                        v-if="step > 1"
                    >
                        Voltar
                    </button>
                </div>
            </div>
        </action-sheet>
    </div>
</template>

<script>
import ActionSheet from "./ActionSheet.vue"
import SelectSearchable from "../components/SelectSearchable.vue"
import { Segments } from "../segments"
import { Budget } from "../budget"
import { filter } from "lodash"
import { Locations } from "../services/locations"

const locations = new Locations()
let timer = null

export default {
    components: {
        ActionSheet,
        SelectSearchable
    },
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            visible: false,
            loadingBudget: false,
            step: 1,
            form: {
                nome: null,
                mensagem: null,
                segmentos: [],
                uf: window.locations?.current || "rn",
                cidade: null,
                bairro: null,
                whatsapp: null,
            },
            segments: [],
            filteredSegments: [],
            loadingSegments: false,
            subcategoryTerm: null,
            errors: [],
            success: false,
            cidades: [],
            bairros: [],
        }
    },
    methods: {
        close() {
            this.$emit("update:modelValue", false)
            this.$emit("dismiss", true)
        },
        sendBudget() {
            this.loadingBudget = true
            this.errors = []
            Budget.store({
                ...this.form
            })
                .then((success) => {
                    this.form = {
                        mensagem: "",
                        whatsapp: "",
                        uf: window.locations?.current || "rn",
                        cidade: null,
                        nome: "",
                        bairro: "",
                        segmentos: [],
                    }

                    this.success = true
                })
                .catch((err) => {
                    for (const [key, value] of Object.entries(
                        err.response.data.errors
                    )) {
                        this.errors.push(value[0])
                    }
                })
                .finally(() => {
                    this.loadingBudget = false
                })
        },
        selectCategory(category, index) {
            this.form.segmentos.push(category)
            this.filteredSegments.splice(index, 1)
        },
        unselectCategory(category, index) {
            this.form.segmentos.splice(index, 1)
            this.filteredSegments.push(category)
        },
        loadSegments() {
            this.loadingSegments = true
            Segments.search(this.subcategoryTerm)
                .then((response) => {
                    this.segments = response.data
                    this.filteredSegments =
                        this.filterSelectedSegments(response.data)
                })
                .catch((e) => {
                    this.segments = false
                    this.filteredSegments = []
                })
                .finally(() => {
                    this.loadingSegments = false
                })
        },
        filterSelectedSegments(segments) {
            return filter(segments, (subcategory) => {
                return !this.form.segmentos.includes(subcategory)
            })
        },
        loadCidades() {
            this.cidades = [
                {
                    slug: "",
                    nome: "Cidade",
                },
            ]
            locations.cidades({ uf: this.form.uf }).then((response) => {
                this.cidades.push(...response.data)
            })
        },
        loadBairros() {
            this.bairros = [
                {
                    slug: "",
                    nome: "Bairro",
                },
            ]
            if (!this.form.cidade) return
            locations.bairros({ cidade: this.form.cidade }).then((response) => {
                this.bairros.push(...response.data)
            })
        },
    },
    mounted() {
        this.visible = this.modelValue
        this.loadSegments()
        this.loadCidades()
    },
    watch: {
        modelValue(n) {
            this.visible = n
        },
        subcategoryTerm(n, old) {
            if (timer) clearTimeout(timer)

            timer = setTimeout(() => this.loadSegments(), 600)
        },
        visible(n, old) {
            if (!n) this.close()
        },
        "form.cidade": {
            deep: true,
            handler() {
                this.loadBairros()
            },
        }
    },
    computed: {
        buttonDisabled() {
            if (this.loadingBudget) return true

            if (this.step == 1) {
                return !this.form.mensagem
            }

            if (this.step == 2) {
                return this.form.segmentos.length == 0
            }

            const regex =
                /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)(?:((?:9\s?\d|[2-9])\d{3})\-?(\d{4}))$/

            if (this.step == 3) {
                return (
                    !this.form.bairro ||
                    !regex.test(this.form.whatsapp) ||
                    this.loadingBudget
                )
            }
        },
    }
}
</script>

<style lang="scss">
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";
.illustration {
    width: 84px;

    @include media-breakpoint-up(md) {
        width: 120px;
    }
}
.message {
    min-height: 200px;
}

@include media-breakpoint-up(md) {
    .budget-content {
        min-height: 300px;
    }
}

.budget-progress {
    display: flex;
    height: 6px;
    gap: 4px;

    .step {
        width: 100%;
        height: 100%;
        border-radius: 4px;

        background: #ffddd6;

        transition: 0.3s ease-in-out;

        &.active {
            background: #ff755c;
        }
    }
}
button:disabled {
    opacity: 0.7;
}
.budget-container .select-searchable .dropdown-button {
    border-style: solid;
    border-width: 1px;
    padding: 12px;
    border-radius: 12px!important;
    margin-bottom: 20px;
    border-color: #e6e6e8 !important;
}
</style>
